import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';

export default function Unauthorized() {
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowContent(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  if (!showContent) return null;

  return (
    <Box alignItems="center" justifyContent="center" mx="auto">
      <Avatar
        src="../assets/app/unauthorized-logo.png"
        sx={{ width: 200, height: 150, marginX: 'auto' }}
      />
      <CardContent>
        <div style={{ textAlign: 'center' }}>
          <Typography
            gutterBottom
            component="div"
            sx={{
              fontSize: 20,
              fontWeight: 'bold',
              display: 'inline-block',
              verticalAlign: 'middle',
            }}
          >
            Access to this page is restricted
          </Typography>
        </div>
        <Typography
          gutterBottom
          variant="body2"
          color="text.secondary"
          component="div"
          sx={{ mx: 'auto', textAlign: 'center', fontSize: 15 }}
        >
          Please contact the administrator to grant the access.
        </Typography>
      </CardContent>
    </Box>
  );
}
